/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Dropdown, Table, Modal } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { PropagateLoader } from 'react-spinners';
import { useTranslate } from '../../hooks/LanguageProvider';
import { formatDurationWithDays, toTimestamp } from '../../utilities/functions';
import ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { toast, Bounce } from 'react-toastify';
import { NavLink } from 'react-router-dom';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface ReportData {
  id_repport: number;
  psn: string;
  ibutton_code: string;
  nbr_tags: number;
  tags_list: string;
  work_hours: number | string;
  idle_hours: number | string;
  park_hours: number | string;
  distance?: number | string;
  avg_speed?: number | string;
  max_speed?: number | string;
  start: string;
  end: string;
}

interface RecapData {
  id_repport: number;
  type_report: number;
  turn_report: number;
  date_creation: string;
  date_debut: string;
  date_fin: string;
}

interface Report52Props {
  type_report?: string;
  turn?: string;
  id_report?: string;
}

const Report52: React.FC<Report52Props> = ({ turn }) => {
  const { translate } = useTranslate();

  const [reports, setReports] = useState<ReportData[]>([]);
  const [recap, setRecap] = useState<RecapData | undefined>();
  const [loading, setLoading] = useState<boolean>(true);

  const [limit, setLimit] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalRows, setTotalRows] = useState<number>(0);

  const [colum, setColum] = useState<string>('id_repport');
  const [sort, setSort] = useState<'ASC' | 'DESC'>('ASC');
  const [search, setSearch] = useState<string>('');
  const [type, setType] = useState<number>(0);
  const [typeSearch, setTypeSearch] = useState<string>(translate('Report ID'));

  const [showDownload, setShowDownload] = useState<boolean>(false);

  const pageCount = useMemo(() => {
    return Math.max(1, Math.ceil(totalRows / Math.max(1, limit)));
  }, [totalRows, limit]);

  const [selectedColumns, setSelectedColumns] = useState({
    id_repport: true,
    end: true,
    psn: true,
    ibutton_code: true,
    nbr_tags: true,
    tags_list: true,
    work_hours: true,
    idle_hours: true,
    park_hours: true,
    distance: true,
    avg_speed: true,
    max_speed: true,
    start: true,
  });

  const labelsMap: Record<keyof typeof selectedColumns, string> = {
    id_repport: translate('Report ID'),
    end: translate('Date'),
    psn: translate('PSN'),
    ibutton_code: translate('First Tag'),
    nbr_tags: translate('Total Tags'),
    tags_list: translate('Tags List'),
    work_hours: translate('Working Hours'),
    idle_hours: translate('Idle Hours'),
    park_hours: translate('Parking Hours'),
    distance: translate('Distance'),
    avg_speed: translate('Average Speed'),
    max_speed: translate('Max Speed'),
    start: translate('Start Time'),
  };

  const handleColumnChange = (key: keyof typeof selectedColumns) => {
    setSelectedColumns((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  async function getReport(params: {
    page0: number;
    limit: number;
    search: string;
    type: number;
    colum: string;
    sort: 'ASC' | 'DESC';
  }) {
    const { page0, limit, search, type, colum, sort } = params;
    const page1 = page0 + 1;

    setLoading(true);
    try {
      const bodyData = JSON.stringify({
        limit,
        page: page1,
        search,
        type,
        turn,
        colum,
        sort,
      });

      const totalRes = await fetch(`${backendUrl}/api/Report52/totalpage`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: bodyData,
        mode: 'cors',
      });
      const totalJson = await totalRes.json();
      setTotalRows(Number(totalJson?.[0]?.total || 0));

      const dataRes = await fetch(`${backendUrl}/api/Report52`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: bodyData,
        mode: 'cors',
      });
      const dataJson = await dataRes.json();
      setReports(Array.isArray(dataJson?.reportData) ? dataJson.reportData : []);
      setRecap(dataJson?.recap);
    } catch (e) {
      console.error('getReport error:', e);
      setReports([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getReport({ page0: currentPage, limit, search, type, colum, sort });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, limit, colum, sort, type, turn]);

  useEffect(() => {
    setCurrentPage(0);
  }, [search]);

  const handlePageClick = (ev: { selected: number }) => setCurrentPage(ev.selected);

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLimit(Number(e.target.value) || 10);
    setCurrentPage(0);
  };

  const handleSortingColum = (col: string) => {
    setColum(col);
    setSort((prev) => (prev === 'ASC' ? 'DESC' : 'ASC'));
    setCurrentPage(0);
  };

  const handleAdvancedSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value || '');
  };

  const handleResetSearch = () => setSearch('');

  const menuItems = [
    translate('Report ID'),
    translate('PSN'),
    translate('First Tag'),
    translate('Total Tags'),
    translate('Tags List'),
    translate('Working Hours'),
    translate('Idle Hours'),
    translate('Parking Hours'),
    translate('Distance'),
    translate('Average Speed'),
    translate('Max Speed'),
    translate('Start Time'),
    translate('Date'),
  ];

  const handleTypeSearch = (selected: string) => {
    switch (selected) {
      case translate('Report ID'):
        setType(0);
        break;
      case translate('PSN'):
        setType(1);
        break;
      case translate('First Tag'):
        setType(2);
        break;
      case translate('Total Tags'):
        setType(3);
        break;
      case translate('Tags List'):
        setType(4);
        break;
      case translate('Working Hours'):
        setType(5);
        break;
      case translate('Idle Hours'):
        setType(6);
        break;
      case translate('Parking Hours'):
        setType(7);
        break;
      case translate('Start Time'):
        setType(8);
        break;
      case translate('Date'):
        setType(9);
        break;
      case translate('Distance'):
        setType(10);
        break;
      case translate('Average Speed'):
        setType(11);
        break;
      case translate('Max Speed'):
        setType(12);
        break;
      default:
        break;
    }

    setTypeSearch(selected);
    setCurrentPage(0);
  };

  function copyToClipboard(value: any) {
    const t = document.createElement('textarea');
    t.value = String(value ?? '');
    document.body.appendChild(t);
    t.select();
    document.execCommand('copy');
    document.body.removeChild(t);

    toast.success(translate('Copied successfully'), {
      position: 'bottom-right',
      autoClose: 2000,
      theme: 'light',
      transition: Bounce,
    });
  }

  function buildHeadersAndRows() {
    const headers: string[] = [];

    const pushIf = (key: keyof typeof selectedColumns, label: string) => {
      if (selectedColumns[key]) headers.push(label);
    };

    pushIf('id_repport', labelsMap.id_repport);
    pushIf('end', labelsMap.end);
    pushIf('psn', labelsMap.psn);
    pushIf('ibutton_code', labelsMap.ibutton_code);
    pushIf('nbr_tags', labelsMap.nbr_tags);
    pushIf('tags_list', labelsMap.tags_list);
    pushIf('work_hours', labelsMap.work_hours);
    pushIf('idle_hours', labelsMap.idle_hours);
    pushIf('park_hours', labelsMap.park_hours);
    pushIf('distance', labelsMap.distance);
    pushIf('avg_speed', labelsMap.avg_speed);
    pushIf('max_speed', labelsMap.max_speed);
    pushIf('start', labelsMap.start);

    const rows = reports.map((r) => {
      const row: any[] = [];
      const add = (cond: boolean, val: any) => {
        if (cond) row.push(val);
      };

      add(selectedColumns.id_repport, r.id_repport);
      add(selectedColumns.end, r.end ? String(r.end).split('T')[0].split(' ')[0] : '');
      add(selectedColumns.psn, r.psn ?? '');
      add(selectedColumns.ibutton_code, r.ibutton_code ?? '');
      add(selectedColumns.nbr_tags, r.nbr_tags ?? 0);
      add(selectedColumns.tags_list, r.tags_list ?? '');
      add(selectedColumns.work_hours, formatDurationWithDays(Math.round(Number(r.work_hours || 0) * 3600)));
      add(selectedColumns.idle_hours, formatDurationWithDays(Math.round(Number(r.idle_hours || 0) * 3600)));
      add(selectedColumns.park_hours, formatDurationWithDays(Math.round(Number(r.park_hours || 0) * 3600)));
      add(selectedColumns.distance, r.distance ?? 0);
      add(selectedColumns.avg_speed, r.avg_speed ?? 0);
      add(selectedColumns.max_speed, r.max_speed ?? 0);
      add(selectedColumns.start, r.start ?? '');

      return row;
    });

    return { headers, rows };
  }

  async function exportExcelStyled() {
    try {
      const { headers, rows } = buildHeadersAndRows();

      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet('TAG Activity Report', {
        properties: { defaultRowHeight: 22 },
        views: [{ state: 'frozen', ySplit: 3 }],
      });

      const title = `${translate('TAG Activity Report')} – ${translate('Turn')} ${recap?.turn_report ?? '-'}`;
      ws.mergeCells(1, 1, 1, Math.max(1, headers.length));
      ws.getCell(1, 1).value = title;
      ws.getCell(1, 1).font = { size: 14, bold: true };
      ws.getCell(1, 1).alignment = { vertical: 'middle', horizontal: 'center' };

      const period = `${translate('From')} ${toTimestamp(recap?.date_debut ?? '')} ${translate('to')} ${toTimestamp(recap?.date_fin ?? '')}`;
      ws.mergeCells(2, 1, 2, Math.max(1, headers.length));
      ws.getCell(2, 1).value = period;
      ws.getCell(2, 1).font = { size: 11, italic: true };
      ws.getCell(2, 1).alignment = { vertical: 'middle', horizontal: 'center' };

      const headerRow = ws.addRow(headers);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F4E78' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      });

      rows.forEach((values) => {
        ws.addRow(values);
      });

      const buf = await wb.xlsx.writeBuffer();
      const blob = new Blob([buf], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `TAG_Activity_Report_T${recap?.turn_report ?? '-'}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Excel export error:', err);
    }
  }

  function exportPDF() {
    try {
      const { headers, rows } = buildHeadersAndRows();
      const doc = new jsPDF('l', 'pt');
      doc.setFontSize(16);
      doc.text(`${translate('TAG Activity Report')} – ${translate('Turn')} ${recap?.turn_report ?? '-'}`, 40, 40);
      doc.setFontSize(10);
      doc.text(`${translate('From')} ${toTimestamp(recap?.date_debut ?? '')} ${translate('to')} ${toTimestamp(recap?.date_fin ?? '')}`, 40, 58);

      autoTable(doc, {
        head: [headers],
        body: rows,
        startY: 80,
        styles: { fontSize: 9, cellPadding: 4, halign: 'center' },
        headStyles: { fillColor: [31, 78, 120], textColor: 255, halign: 'center' },
      });

      doc.save(`TAG_Activity_Report_T${recap?.turn_report ?? '-'}.pdf`);
    } catch (err) {
      console.error('PDF export error:', err);
    }
  }

  return (
    <>
      <div className="row">
        <div className="col-sm-6 col-md-6">
          <h6>
            <i className="las la-chart-bar" /> {translate('TAG Activity Report')} : {totalRows}
          </h6>
        </div>
        <div className="col-sm-6 col-md-6">
          <div className="float-right dataTables_filter mr-3">
            <NavLink to="/driver-behavior-config" className="btn btn-primary mr-1">
              <i className="las la-cog mr-3"></i>
              {translate('Configuration')}
            </NavLink>
            <Button variant="outline-secondary" className="mr-2" onClick={() => setShowDownload(true)}>
              <i className="las la-download mr-2" />
              {translate('Download')}
            </Button>
          </div>
        </div>
      </div>

      <div className="row m-2">
        <div className="col-sm-6 col-md-6" style={{ margin: '0 0 10px 0', padding: 0 }}>
          <div className="input-group">
            <Dropdown>
              <Dropdown.Toggle variant="link" id="dropdown-basic">
                <i className="fas fa-chevron-down" style={{ fontSize: 20 }} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {menuItems.map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={() => handleTypeSearch(item)}
                    eventKey={item}
                    active={typeSearch === item}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <input
              type="text"
              placeholder={` ${translate('Search by')} ${translate(typeSearch)}`}
              onChange={handleAdvancedSearch}
              className="form-control"
              value={search}
            />

            <Button variant="secondary" onClick={handleResetSearch} className="btn-reset">
              <i className="las la-times" style={{ color: '#fff' }} />
            </Button>
          </div>
        </div>

        <div className="col-md-6 d-flex justify-content-end align-items-center">
          <div className="dataTables_length">
            <label style={{ float: 'right' }}>
              {translate('Show')}
              <select
                className="custom-select custom-select-sm form-control form-control-sm mr-2 ml-2"
                style={{ width: 66 }}
                onChange={handleSelectChange}
                value={String(limit)}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>

          <Dropdown>
            <Dropdown.Toggle variant="" id="dropdown-cols" title={translate('Display columns')}>
              <i className="las la-eye" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {Object.keys(selectedColumns).map((key) => (
                <Dropdown.Item key={key} as="button" style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={(selectedColumns as any)[key]}
                    onChange={() => handleColumnChange(key as keyof typeof selectedColumns)}
                  />
                  <span style={{ marginLeft: 10 }}>
                    {labelsMap[key as keyof typeof selectedColumns]}
                  </span>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="row m-1 table-responsive">
        <h6>
          Nr.Tournée: {recap?.turn_report}, {translate('From')}{' '}
          <span style={{ color: '#3468C0' }}>{toTimestamp(recap?.date_debut ?? '')}</span>{' '}
          {translate('to')}{' '}
          <span style={{ color: '#3468C0' }}>{toTimestamp(recap?.date_fin ?? '')}</span>
        </h6>

        <Table className="dataTable">
          <thead className="bg-white">
            <tr>
              {selectedColumns.id_repport && <th onClick={() => handleSortingColum('id_repport')}>{translate('Report ID')}</th>}
              {selectedColumns.end && <th onClick={() => handleSortingColum('end')}>{translate('Date')}</th>}
              {selectedColumns.psn && <th onClick={() => handleSortingColum('psn')}>{translate('PSN')}</th>}
              {selectedColumns.ibutton_code && <th onClick={() => handleSortingColum('ibutton_code')}>{translate('First Tag')}</th>}
              {selectedColumns.nbr_tags && <th onClick={() => handleSortingColum('nbr_tags')}>{translate('Total Tags')}</th>}
              {selectedColumns.tags_list && <th onClick={() => handleSortingColum('tags_list')}>{translate('Tags List')}</th>}
              {selectedColumns.work_hours && <th onClick={() => handleSortingColum('work_hours')}>{translate('Working Hours')}</th>}
              {selectedColumns.idle_hours && <th onClick={() => handleSortingColum('idle_hours')}>{translate('Idle Hours')}</th>}
              {selectedColumns.park_hours && <th onClick={() => handleSortingColum('park_hours')}>{translate('Parking Hours')}</th>}
              {selectedColumns.distance && <th onClick={() => handleSortingColum('distance')}>{translate('Distance')}</th>}
              {selectedColumns.avg_speed && <th onClick={() => handleSortingColum('avg_speed')}>{translate('Average Speed')}</th>}
              {selectedColumns.max_speed && <th onClick={() => handleSortingColum('max_speed')}>{translate('Max Speed')}</th>}
              {selectedColumns.start && <th onClick={() => handleSortingColum('start')}>{translate('Start Time')}</th>}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan={13}>
                  <PropagateLoader loading={loading} size={20} />
                </td>
              </tr>
            ) : reports.length > 0 ? (
              reports.map((data, index) => (
                <tr key={`${data.id_repport}-${index}`}>
                  {selectedColumns.id_repport && <td>{data.id_repport}</td>}
                  {selectedColumns.end && <td>{data.end ? String(data.end).split('T')[0].split(' ')[0] : ''}</td>}
                  {selectedColumns.psn && <td>{data.psn}</td>}
                  {selectedColumns.ibutton_code && (
                    <td
                      onClick={() => copyToClipboard(data.ibutton_code)}
                      style={{ cursor: 'pointer' }}
                    >
                      {data.ibutton_code}
                    </td>
                  )}
                  {selectedColumns.nbr_tags && <td>{data.nbr_tags}</td>}
                  {selectedColumns.tags_list && <td>{data.tags_list}</td>}
                  {selectedColumns.work_hours && <td>{formatDurationWithDays(Math.round(Number(data.work_hours) * 3600))}</td>}
                  {selectedColumns.idle_hours && <td>{formatDurationWithDays(Math.round(Number(data.idle_hours) * 3600))}</td>}
                  {selectedColumns.park_hours && <td>{formatDurationWithDays(Math.round(Number(data.park_hours) * 3600))}</td>}
                  {selectedColumns.distance && <td>{data.distance ?? 0}</td>}
                  {selectedColumns.avg_speed && <td>{data.avg_speed ?? 0}</td>}
                  {selectedColumns.max_speed && <td>{data.max_speed ?? 0}</td>}
                  {selectedColumns.start && <td>{toTimestamp(data.start)}</td>}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={13}>No report available</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="row">
        <div className="col-md-6 d-flex align-items-center">
          <span>
            {translate('Displaying')} {reports.length} {translate('on')} {totalRows}
          </span>
        </div>

        <div className="col-md-6 d-flex justify-content-end">
          <ReactPaginate
            previousLabel={translate('previous')}
            nextLabel={translate('next')}
            breakLabel={'...'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination justify-right'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}
            forcePage={Math.min(currentPage, pageCount - 1)}
          />
        </div>
      </div>

      <Modal show={showDownload} onHide={() => setShowDownload(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{translate('Select Download Format')}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {translate('Please select the format to download the data')}
          <div className="mt-3 d-flex justify-content-center">
            <Button
              variant="success"
              className="mr-2"
              onClick={() => {
                setShowDownload(false);
                exportExcelStyled();
              }}
            >
              Excel
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                setShowDownload(false);
                exportPDF();
              }}
            >
              PDF
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Report52;